import client from './client';

// 폰 푸시(FCM) 토큰 등록/해제 + 알림종류별 수신 설정.
const TOKEN_URL = '/api/v1/common/push-token';
const PREF_URL = '/api/v1/common/push-pref';

export const registerPushToken = (token, platform, deviceInfo, appVersion) =>
  client.post(TOKEN_URL, { token, platform, deviceInfo, appVersion });

export const unregisterPushToken = (token) =>
  client.delete(TOKEN_URL, { params: { token } });

/** { list: [{ notiTyp, label, enabled }] } */
export const fetchPushPrefs = () => client.get(PREF_URL);

export const savePushPref = (notiTyp, enabled) =>
  client.put(PREF_URL, { notiTyp, enabled });
